// extracted by mini-css-extract-plugin
export default {"language":"Language_language__-0IpI","solo":"Language_solo__bfi+k","border":"Language_border__RGlw6"};